export default __webpack_public_path__ + "static/media/step3.c2a90581.jpg";